import { render } from "./DocumentStatusEditInPlace.vue?vue&type=template&id=d018bf06&scoped=true"
import script from "./DocumentStatusEditInPlace.vue?vue&type=script&lang=js"
export * from "./DocumentStatusEditInPlace.vue?vue&type=script&lang=js"

import "./DocumentStatusEditInPlace.vue?vue&type=style&index=0&id=d018bf06&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d018bf06"]])

export default __exports__